import React from "react";

interface FormTextAreaProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: string;
  placeholder?: string;
  rows?: number;
}

const FormTextArea: React.FC<FormTextAreaProps> = ({
  label,
  name,
  value,
  onChange,
  error,
  placeholder,
  rows = 2,
}) => {
  const borderColor = error
    ? "border-red-500"
    : value.trim()
    ? "border-green-500"
    : "border-stroke dark:border-form-strokedark";

  return (
    <div className="md:col-span-1">
      <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-white">
        {label}
      </label>
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder || `Enter ${label.toLowerCase()}`}
        rows={rows}
        className={`w-full rounded-lg border py-3 px-4 transition duration-300 focus:outline-none dark:bg-form-input dark:text-white ${borderColor}`}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default FormTextArea;
